export default class EventRegistrationService {
     static eventsWithRegistrations(registrations) {
         let events = {};
         _.each(registrations, r => {
             if (!events.hasOwnProperty(r.event_id.toString())) {
                 events[r.event_id.toString()] = { event: r.event, registrations: [] };
             }
             events[r.event_id.toString()].registrations.push(r);
         });

         let res = [];
         _.each(events, value => {
             res.push(value);
         });

         return res;
    }

    static nextEventsWithoutRegistrations(events, registrations) {
        return _.reject(_.orderBy(events, 'register_end'), e => {
            return e.is_locked ||
                _.some(registrations, r => {
                    return r.event_id === e.id;
                });
        })
    }
}